// src/panel.js
import { CHAT_STYLES } from './styles.css.js';

let stylesInjected = false;
function ensureStyles() {
  if (stylesInjected) return;
  const s = document.createElement('style');
  s.setAttribute('data-attraxion-chat', 'styles');
  s.textContent = CHAT_STYLES;
  document.head.appendChild(s);
  stylesInjected = true;
}

export function createPanel({ onOpen, onClose } = {}) {
  ensureStyles();

  const panel = document.createElement('div');
  panel.className = 'attraxion-chat-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('aria-label', 'Chat');

  // Bottom-right fixed-position panel, hidden until open().
  Object.assign(panel.style, {
    position: 'fixed',
    bottom: '80px',
    right: '16px',
    width: '380px',
    height: '560px',
    zIndex: '2147483647',
    border: 'none',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    overflow: 'hidden',
    display: 'none',
  });

  document.body.appendChild(panel);

  function open() {
    panel.style.display = 'block';
    onOpen?.();
  }

  function close() {
    panel.style.display = 'none';
    onClose?.();
  }

  // Close on Escape key.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && panel.style.display !== 'none') close();
  });

  // Listen for attraxion-chat:close postMessages from the iframe.
  window.addEventListener('message', (e) => {
    if (e.data?.type === 'attraxion-chat:close') close();
  });

  return { panelEl: panel, open, close };
}
